<div class="container-fluid px-5 py-3">
    <div class="d-flex justify-content-between pb-2">
        <span class="text-blue font-weight-bold">
            <h3 class="my-2" translate>menu.adminPanel.nomenclatures.listCustomerDiscounts</h3>
        </span>
    </div>
    <div class="my-2 py-2" *ngIf="loadSearchForm$ | async as data; else loading">
        <!-- ****************************************************** 
        ************** Search Form *************
        ****************************************************** -->
        <form [formGroup]="searchForm">
            <div class="input-group mb-2">
                <!-- name -->
                <div class="input-group-prepend">
                    <span class="input-group-text" translate>customerDiscounts.discountName</span>
                </div>
                <input type="text" class="form-control" style="max-width: 250pt;" (keyup.enter)="search()" formControlName="discountName" id="nameInput">
                
                <!-- status -->
                <div class="input-group-prepend ml-2">
                    <span class="input-group-text" translate>customerDiscounts.valid</span>
                </div>
                <select class="custom-select input-custom-size" formControlName="isValid" style="max-width: 250pt;">
                    <option [value]="true" translate>yes</option>
                    <option [value]="false" translate>no</option>
                </select>

                <!-- Discount Type -->
                <div class="input-group-prepend ml-2">
                    <span class="input-group-text" translate>cardLoyal.discountType</span>
                </div>
                <select class="custom-select input-custom-size" formControlName="discountType" style="max-width: 250pt;">
                    <option selected value translate>placeholder.select</option>
                    <option *ngFor="let type of discountTypes" [ngValue]="type.id">
                        {{ type.description }}
                    </option>
                </select>

                <!-- actions -->
                <div class="input-group-prepend ml-2">
                    <div style="display: flex">
                        <button class="btn btn-outline-success" style="border-radius: 0;" type="button" (click)="search()" translate>button.search</button>
                        <button class="btn btn-outline-danger ml-2" style="border-radius: 0;" type="button" (click)="clearSearch()" translate>button.clear</button>
                    </div>
                </div>
            </div>
        </form>
        <br>
        <!-- ****************************************************** 
        ************** Table Data *************
        ****************************************************** -->
        <div class="d-flex justify-content-center">
            <table class="table table-bordered table-striped w-100" [hidden]="!dataLoaded">
                <thead>
                    <tr>
                        <th style="width: 35%"sortBy="discountName" (sort)="onSort($event)" translate>customerDiscounts.discountName</th>
                        <th style="width: 20%"sortBy="isValid" (sort)="onSort($event)" translate>customerDiscounts.valid</th>
                        <th style="width: 35%"translate>customerDiscounts.discountTypes</th>
                        <th style="width: 10%" translate>clientProfile.actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let customerDiscount of content">
                        <td>{{customerDiscount.discountName}}</td>
                        <td translate> {{customerDiscount.isValid == true? 'Да' : 'Не'}}</td>
                        <td translate> {{customerDiscount.discountTypes}}</td>
                        <td class="text-center py-2">
                            <button class="btn btn-sm btn-success" data-toggle="tooltip" data-placement="bottom" title="{{'button.edit' | translate}}"
                                routerLink="/customer-discounts" [queryParams]="{id: customerDiscount.id}">
                                <i class="fa fa-pencil fa-lg"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <ng-container *ngIf="dataLoaded; else dataLoadingTemplate"></ng-container>
        <!-- ****************************************************** 
        ************** Pagination *************
        ****************************************************** -->
        <div class="paging-wrapper d-flex justify-content-between">
            <select class="pagination-size custom-select" [(ngModel)]="sortingPaging.pageSize" (change)="onPageSizeChange($event)">
                <option *ngFor="let item of pageSizeOptions; let i = index" [value]="pageSizeOptions[i]">
                {{pageSizeOptions[i]}} {{'paging.itemsPerPage' | translate}} 
                </option>
            </select>
            <ngb-pagination class="pagination-control"
                [(page)]="sortingPaging.pageNumber"
                [pageSize]="sortingPaging.pageSize"
                [collectionSize]="sortingPaging.totalElements"
                [boundaryLinks]="true"
                [maxSize]="maxSize"
                (pageChange)="pageChanged($event)">
            </ngb-pagination>
            <span class="pagination-index border center">
                {{sortingPaging.fromRow}} - {{sortingPaging.toRow}} / {{sortingPaging.totalElements}}
            </span>
        </div>
    </div>
</div>

<ng-template #loading>
    <div *ngIf="errorMessage$ | async as errorMessage; else spinner">
        <div class="alert alert-danger">
            {{errorMessage}}
        </div>
        <div class="d-flex justify-content-center">
            <em class="fa fa-refresh" (click)="reload()"></em>
        </div>
    </div>
    <ng-template #spinner>
        <div class="d-flex justify-content-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </ng-template>
</ng-template>

<ng-template #dataLoadingTemplate>
    <div *ngIf="errorMessage$ | async as errorMessage; else dataSpinner">
        <div class="alert alert-danger">
            {{errorMessage}}
        </div>
        <div class="d-flex justify-content-center">
            <i class="fa fa-refresh" (click)="reload()"></i>
        </div>
    </div>
    <ng-template #dataSpinner>
        <div class="d-flex justify-content-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </ng-template>
</ng-template>